import React from 'react';
import styles from './SoftwareDev.module.css';

const SoftwareDev = () => {


  return (
    <div className={styles.cSBackground}>
      <p className={styles.cSInto}>I am an open source, full stack developer with experience in both frontend and backend technologies. See my resume link on the home page for more details.</p>
      <p className={styles.cSText}>More example projects coming soon... Stay tuned!</p>
    </div>
  )
}

export default SoftwareDev;